/**
 * Filtra contenido del markdown basado en permisos del usuario
 *
 * Soporta dos patrones:
 *
 * 1. Contenido solo para unlockAll (se elimina si no tiene permiso):
 *    <!-- UNLOCK_REQUIRED:START -->
 *    ... contenido sensible solo para unlockAll ...
 *    <!-- UNLOCK_REQUIRED:END -->
 *
 * 2. Dos versiones del mismo contenido (unlock vs normal):
 *    <!-- UNLOCK:START -->
 *    ... versión completa/sensible ...
 *    <!-- UNLOCK:END -->
 *    <!-- NORMAL:START -->
 *    ... versión simplificada/pública ...
 *    <!-- NORMAL:END -->
 *
 * Comportamiento:
 * - Si unlockAll = true: Muestra bloques UNLOCK_REQUIRED y UNLOCK, elimina bloques NORMAL
 * - Si unlockAll = false: Elimina bloques UNLOCK_REQUIRED y UNLOCK, muestra bloques NORMAL
 */

export const filterSensitiveContent = (markdownContent, user) => {
  const hasUnlockAll = user && user.unlockAll === true;

  if (hasUnlockAll) {
    // Usuario con unlockAll: Mostrar contenido UNLOCK y UNLOCK_REQUIRED, eliminar NORMAL
    return markdownContent
      .replace(/<!--\s*NORMAL:START\s*-->[\s\S]*?<!--\s*NORMAL:END\s*-->/g, '');
  } else {
    // Usuario sin unlockAll: Eliminar contenido UNLOCK y UNLOCK_REQUIRED, mostrar NORMAL
    return markdownContent
      .replace(/<!--\s*UNLOCK_REQUIRED:START\s*-->[\s\S]*?<!--\s*UNLOCK_REQUIRED:END\s*-->/g, '')
      .replace(/<!--\s*UNLOCK:START\s*-->[\s\S]*?<!--\s*UNLOCK:END\s*-->/g, '');
  }
};

/**
 * Verifica si un contenido tiene secciones restringidas
 */
export const hasSensitiveContent = (markdownContent) => {
  return /<!--\s*UNLOCK_REQUIRED:START\s*-->/.test(markdownContent);
};
